/* =========================================================================================================
   NJ SIZE GUIDE (snippets/size-guide-drawer.liquid)
   Why this file exists: Prestige replaces the variant picker (and the size guide inside it) with freshly fetched
   HTML every time the customer changes size. Scripts inside fetched HTML never run, so listeners attached by an
   inline script stop working after the first variant change. All listeners here are delegated from the document,
   so they keep working for any size guide on the page, including replaced ones and the ones in quick buy.
   ========================================================================================================= */
(() => {
  'use strict';

  const DRAWER_SEL = '[data-nj-size-guide]';
  let currentUnit = 'cm'; // remembered while the customer stays on the page

  function applyUnit(drawer, unit) {
    const useInch = unit === 'inch';

    drawer.querySelectorAll('.nj-sg__unit-btn').forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.unit === unit);
    });
    drawer.querySelectorAll('.nj-sg-height, .nj-sg-mval').forEach((el) => {
      el.textContent = useInch ? el.dataset.inch : el.dataset.cm;
    });
    drawer.querySelectorAll('.nj-sg-unit-lbl').forEach((el) => {
      el.textContent = useInch ? 'IN' : 'CM';
    });
  }

  function updateHighlight(drawer, sizeValue) {
    const norm = (sizeValue || '').toLowerCase();
    drawer.querySelectorAll('[data-select-size]').forEach((el) => {
      el.classList.toggle('is-sel', (el.dataset.selectSize || '').toLowerCase() === norm);
    });
  }

  function selectSize(drawer, sizeValue) {
    const sizePos = drawer.dataset.sizePos;
    if (!sizePos || sizePos === '0') return;

    const formId = drawer.id.replace(/^size-chart-/, '');
    const inputs = document.querySelectorAll(
      'input[type="radio"][data-option-position="' + sizePos + '"][form="' + CSS.escape(formId) + '"]'
    );

    let targetInput = null;
    inputs.forEach((input) => {
      const label = document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
      if (label && label.textContent.trim().toLowerCase() === sizeValue.toLowerCase()) {
        targetInput = input;
      }
    });

    if (!targetInput) return;

    updateHighlight(drawer, sizeValue);
    targetInput.checked = true;
    targetInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!target || !target.closest) return;

    // Opening a size guide: show it in the unit the customer chose last
    const opener = target.closest('[aria-controls^="size-chart-"]');
    if (opener && !opener.closest(DRAWER_SEL)) {
      const drawerToOpen = document.getElementById(opener.getAttribute('aria-controls'));
      if (drawerToOpen && drawerToOpen.matches(DRAWER_SEL)) applyUnit(drawerToOpen, currentUnit);
      return;
    }

    const drawer = target.closest(DRAWER_SEL);
    if (!drawer) return;

    // Womens / Mens tabs
    const tab = target.closest('.nj-sg__tab');
    if (tab) {
      drawer.querySelectorAll('.nj-sg__tab').forEach((b) => b.classList.toggle('is-active', b === tab));
      drawer.querySelectorAll('[data-nj-panel]').forEach((panel) => {
        panel.classList.toggle('is-hidden', panel.dataset.njPanel !== tab.dataset.tab);
      });
      return;
    }

    // CM / INCHES
    const unitBtn = target.closest('.nj-sg__unit-btn');
    if (unitBtn) {
      currentUnit = unitBtn.dataset.unit === 'inch' ? 'inch' : 'cm';
      applyUnit(drawer, currentUnit);
      return;
    }

    // Size conversion (collapsible)
    const trigger = target.closest('.nj-sg__collapsible-trigger');
    if (trigger) {
      const body = drawer.querySelector('.nj-sg__collapsible-body');
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!expanded));
      if (body) body.classList.toggle('is-hidden', expanded);
      return;
    }

    // Clicking a size in the conversion table selects that size on the product
    const cell = target.closest('[data-select-size]');
    if (cell && !cell.closest('.nj-sg__status-row')) {
      selectSize(drawer, cell.dataset.selectSize);
    }
  });

  // Keep the highlighted column in sync when the size is changed on the product.
  // Prestige's "variant:change" event carries the new variant; its options[] are in option-position order.
  document.addEventListener('variant:change', (event) => {
    const variant = event.detail && event.detail.variant;
    if (!variant || !Array.isArray(variant.options)) return;

    // Only the size guide that belongs to this product form (quick buy modals have their own).
    // The event is dispatched on the <form>; read its id attribute (form.id would return the input named "id").
    const form = event.target;
    const formId = form && form.getAttribute ? form.getAttribute('id') : null;
    if (!formId) return;

    const drawer = document.getElementById('size-chart-' + formId);
    if (!drawer || !drawer.matches(DRAWER_SEL)) return;

    const pos = parseInt(drawer.dataset.sizePos || '0', 10);
    if (pos > 0 && variant.options[pos - 1] != null) updateHighlight(drawer, String(variant.options[pos - 1]));
  });
})();
